module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/avellino.8cb0b94f2348d0dd6b1120e6546e8bbd.jpg";